import { Grid } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import claimManagementStyles from "../../Styles/claimManagement";

const HolidayStructureAssignationFormTable = ({
    clickSubmitHandler,
    allChecked,
    handleAllCheckedClick,
    salesTeamDataList,
    handleCheckBoxClick,
}) => {


    const [searchValue, setSeachValue] = React.useState("");

    const onSearchValue = (searchValue) => {
        setSeachValue(searchValue);
    };

    const getFilteredTableData = (tableData) => {
        return tableData.filter((currentRow) => {
            let isValid = false;
            let name =
                currentRow.name != null ? currentRow.name : "";
            let stockStakeHolderTypeName =
                currentRow.stockStakeHolderTypeName != null ? currentRow.stockStakeHolderTypeName : "";

            if (
                name &&
                name.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            } else if (
                stockStakeHolderTypeName &&
                stockStakeHolderTypeName.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    return (
        <>
            {salesTeamDataList.length !== 0 && (
                <>
                    <LandingScreenHeader
                        screenTitle={""}
                        showSearchBox={true}
                        showTable={true}
                        showFilter={false}
                        showPdfDownload={false}
                        showExcelDownload={false}
                        onSearch={onSearchValue}
                    />


                    <div
                        style={{
                            overflowX: "auto",
                            overflowY: "auto",
                            maxHeight: "500px",
                            position: "relative",
                        }}
                    >
                        <table
                            style={{
                                borderCollapse: "collapse",
                                width: "100%",
                                textAlign: "center",
                            }}
                        >
                            <thead
                                style={{
                                    position: "sticky",
                                    top: 0,
                                    background: "#03a9f4",
                                    zIndex: 3,
                                    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                }}
                            >
                                <tr>
                                    <th
                                        style={{
                                            ...claimManagementStyles.tableHeadStyle,
                                            minWidth: "60px",
                                        }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={allChecked}
                                            style={{
                                                width: "18px",
                                                height: "18px",
                                                cursor: "pointer",
                                                accentColor: allChecked ? "#f44336" : "#03a9f4"
                                            }}
                                            onChange={handleAllCheckedClick}
                                        />
                                    </th>

                                    <th
                                        style={{
                                            ...claimManagementStyles.tableHeadStyle,
                                            minWidth: "100px",
                                        }}
                                    >
                                        Sr. No
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "230px", }}>
                                        Sales Team Name
                                    </th>

                                    <th style={{ ...claimManagementStyles.tableHeadStyle, minWidth: "190px", }}>
                                        Sales Team Type
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {getFilteredTableData(salesTeamDataList).map((dataObj, index) => (
                                    <tr key={dataObj.id}>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "center",
                                            }}
                                        >
                                            <input
                                                type="checkbox"
                                                style={{
                                                    transform: "scale(1.5)",
                                                    margin: "0 8px",
                                                }}
                                                checked={dataObj.isChecked}
                                                onChange={(e) =>
                                                    handleCheckBoxClick(e, dataObj.id)
                                                }
                                            />
                                        </td>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "center",
                                            }}
                                        >
                                            {dataObj.index !== null ? dataObj.index : ""}
                                        </td>
                                        <td
                                            style={{
                                                ...claimManagementStyles.cellStyle,
                                                textAlign: "left",
                                            }}
                                        >
                                            {dataObj.name !== null ? dataObj.name : ""}
                                        </td>

                                        <td style={{ ...claimManagementStyles.cellStyle, textAlign: "left" }}>
                                            {dataObj.stockStakeHolderTypeName !== null ? dataObj.stockStakeHolderTypeName : ""}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <br />
                    <Grid
                        item
                        sm={12}
                        xs={12}
                        md={12}
                        lg={12}
                        container
                        justifyContent="flex-end"
                        gap={2}
                    >
                        <ButtonCompo
                            sx={{
                                bgcolor: "dodgerblue",
                                color: "#fbff00",
                            }}
                            size="medium"
                            type="button"
                            variant="contained"
                            name={"Submit"}
                            onClick={clickSubmitHandler}
                            fullWidth={false}
                        />
                    </Grid>
                </>
            )}
        </>
    );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(HolidayStructureAssignationFormTable);
